import React from 'react';
import PropTypes from 'prop-types';
import { Navigate, useLocation } from 'react-router-dom';

import { getCaptureRouteEquivalent } from 'features/govtId/v2/lib/provider';

/**
 * Keeps users out of the original flow's capture screens: a stale link, the browser history or a
 * typed URL lands on the v2 counterpart. Everything else under `/govtid` is shared with v2 and
 * renders as usual.
 */
const GovtIdProviderGuard = ({ children }) => {
    const { pathname, search } = useLocation();

    const equivalent = getCaptureRouteEquivalent(pathname);

    if (equivalent) return <Navigate to={`${equivalent}${search}`} replace />;

    return children;
};

GovtIdProviderGuard.propTypes = {
    children: PropTypes.node,
};

export default GovtIdProviderGuard;
